import React, {PropTypes} from 'react';
import {
    buildCurrency,
    buildNumber
} from '../../../../shared/services/build-number';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import RecoveryPercentageIcon from '../recovery-percentage-icon';
import ReimbursementSummaryLeadAccount from '@deere/cps-it.warranty-model-factory/lib/reimbursement-summary-lead-account';
import User from '@deere/cps-it.warranty-model-factory/lib/user';

const handleTitleClick = (props, leadAccount) => () =>
    props.onLeadAccountChange(leadAccount.leadAccount.account);

const getLeadAccountPanelItemClassName = isSelected =>
    isSelected ?
        'lead-account-panel-item selected' :
        'lead-account-panel-item';

const LeadAccountPanelItem = (props, context) =>
    <Link to='/reimbursement-summary'>
        <li
            className={getLeadAccountPanelItemClassName(props.isSelected)}
            onClick={handleTitleClick(props, props.leadAccount)}
        >
            <div className='row'>
                <div className='title'>
                    {props.leadAccount.leadAccount.name}
                </div>
                <RecoveryPercentageIcon
                    recoveryPercentage={props.leadAccount.recoveryPercentage}
                />
            </div>
            <div className='row'>
                <div className='total-unpaid'>
                    {buildCurrency(props.leadAccount.totalUnpaid, context.user.settings.general.decimalFormat.key)}
                </div>
                <div className='recovery-percentage'>
                    <FormattedMessage
                        id='PERCENTAGE_SYMBOL'
                        values={{
                            percentage: buildNumber(props.leadAccount.recoveryPercentage)
                        }}
                    />
                </div>
            </div>
        </li>
    </Link>;

LeadAccountPanelItem.displayName = 'LeadAccountPanelItem';
LeadAccountPanelItem.propTypes = {
    isSelected: PropTypes.bool.isRequired,
    leadAccount: PropTypes.instanceOf(ReimbursementSummaryLeadAccount).isRequired,
    onLeadAccountChange: PropTypes.func.isRequired
};
LeadAccountPanelItem.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default LeadAccountPanelItem;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/reimbursement-summary-aside/lead-account-panel-item.js